<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-radio
                    label="{{ getLabelFiscalityField() }}"
                    formControlName="fiscality"
                    direction="column"
                    [isDefault]="false"
                    [options]="options"
                    columns="2"
                  >
                  </pr-input-radio>
                </div>
              </div>
              @if (avInvestmentType?.value === 'INITIAL_AND_MONTHLY') {
                <div class="row">
                  <div class="col col-md-12">
                    <pr-input-radio
                      label="Fiscalité de votre versement programmé"
                      formControlName="fiscalityProgrammed"
                      direction="column"
                      [isDefault]="false"
                      [options]="options"
                      columns="2"
                    >
                    </pr-input-radio>
                  </div>
                </div>
              }
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
